import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import {
  useFinstrongStore,
  useGlobalCopyStore,
  useScreenSize,
  useUserStore,
  useWidgetContainerProvider,
} from '../../../common'

import { CreditScoreGraph } from '../CreditScoreGraph'
import ManageCreditScore from '../ManageCreditScore'
import LineGraph from '../shared/LineGraph'

const CreditScoreContent = () => {
  const { healthScoreChangeReports } = useFinstrongStore()
  const { finstrong: copy } = useGlobalCopyStore()
  const { user } = useUserStore()
  const { availableWidth } = useWidgetContainerProvider()
  const { isSmallMobile } = useScreenSize(availableWidth)

  const [isOpen, setIsOpen] = React.useState(false)

  const lastReport = healthScoreChangeReports.at(-1)

  return (
    <Box>
      <Stack sx={{ gap: 28 }}>
        <CreditScoreGraph
          arcRadius={isSmallMobile ? 124 : 154}
          footerCenterContent={
            lastReport ? lastReport.newer_credit_score - lastReport.older_credit_score : 0
          }
          healthScore={user.credit_score ?? 0}
          size={isSmallMobile ? 'M' : 'L'}
        />
        <Button onClick={() => setIsOpen(true)} variant="contained">
          {copy.credit_score_updated_score}
        </Button>
        <LineGraph chartFor="creditOverTime" />
      </Stack>
      <ManageCreditScore isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </Box>
  )
}

export default observer(CreditScoreContent)
